:host {
  display: block;
}

#nextActionBlock {
    width: 347px;
    background-color: #F6F7F8;
    box-shadow: 0px 0px 16px 0px rgba(24, 27, 32, 0.10);
}

#already-registered-view {
    height: 383px;
}

.card {
    min-height: 353px;
}

.bg-lyreco-green {
    background-color: #9AC31C;
}

@media screen and (max-width: 1221px) {

    #nextActionBlock {
        width: 100%;
    }
}
